import { render, staticRenderFns } from "./Folio.vue?vue&type=template&id=06357a8f"
import script from "./Folio.vue?vue&type=script&lang=js"
export * from "./Folio.vue?vue&type=script&lang=js"
import style0 from "./Folio.vue?vue&type=style&index=0&id=06357a8f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports